import React, { useContext } from 'react'
import { useQuery } from 'react-query'
import { getCurrentModeratorAnalysis, getCurrentModeratorModulesByGrade } from '../../../Api/moduleModeratorApi'
import { UserContext } from '../../../Context/Usercontext'
import TabbedDashboard from './components/TabbedDashboard'
import Loading from '../../../components/Loading/Loading'
import "./Modulemoderatordashboard.scss"

export default function Modulemoderatordashboard() {
  const { userId } = useContext(UserContext);

  // Fetch current moderator's analysis
  const { data: moderatorAnalysis, isLoading: analysisLoading, error: analysisError } = useQuery(
    ['currentModeratorAnalysis', userId],
    () => getCurrentModeratorAnalysis(userId),
    {
      enabled: !!userId,
      refetchInterval: 30000, // Refetch every 30 seconds
    }
  );

  // Fetch current moderator's modules by grade
  const { data: modulesByGrade, isLoading: modulesLoading, error: modulesError } = useQuery(
    ['currentModeratorModules', userId],
    () => getCurrentModeratorModulesByGrade(userId),
    {
      enabled: !!userId,
      refetchInterval: 30000,
    }
  );

  const handleModuleAnalysis = (moduleId) => {
    // Module analysis functionality can be implemented here
    console.log('Module analysis requested for:', moduleId);
  };

  if (analysisLoading || modulesLoading) {
    return <Loading />;
  }

  if (analysisError || modulesError) {
    return (
      <div className="error-container">
        <h2>Error loading dashboard data</h2>
        <p>Please try refreshing the page.</p>
      </div>
    );
  }

  return (
    <div className="module-moderator-dashboard">
      <div className="dashboard-header">
        <h1 className="dashboard-title">My Dashboard</h1>
        <p className="dashboard-subtitle">Personal overview of your modules and performance</p>
      </div>

      {/* Tabbed Dashboard */}
      <TabbedDashboard 
        moderatorAnalysis={moderatorAnalysis}
        modulesByGrade={modulesByGrade}
        onModuleAnalysis={handleModuleAnalysis}
      />
    </div>
  );
}
